import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge doesn't know about the custom nhp-* theme tokens out of the
// box, so passing e.g. "bg-background bg-nhp-surface" to cn() left BOTH
// classes in the DOM instead of dropping the base one — whichever ended up
// later in the compiled stylesheet won, independent of prop order, which is
// why shared shadcn components (Dialog, etc.) rendered inconsistently after
// the admin theme conversion. Registering them closes that gap.
const NHP_COLOR_TOKENS = [
  "nhp-bg", "nhp-surface", "nhp-border", "nhp-text", "nhp-muted",
  "nhp-primary", "nhp-primary-hover", "nhp-on-primary",
  "nhp-warning", "nhp-critical", "nhp-info",
];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "bg-color": NHP_COLOR_TOKENS.map((t) => `bg-${t}`),
      "text-color": NHP_COLOR_TOKENS.map((t) => `text-${t}`),
      "border-color": NHP_COLOR_TOKENS.map((t) => `border-${t}`),
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
